/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext, useState } from 'react';

import { Button } from '@coursera/cds-core';
import { EditIcon, TrashIcon } from '@coursera/cds-icons';

import TooltipOverlay from 'bundles/grading/components/common/TooltipOverlay';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import ApplyGradeOverrideDialog from 'bundles/grading/components/staff-graded-assignments/grade-override/ApplyGradeOverrideDialog';
import DeleteGradeOverrideDialog from 'bundles/grading/components/staff-graded-assignments/grade-override/DeleteGradeOverrideDialog';

import _t from 'i18n!nls/grading';

const styles = {
  container: () => css`
    margin-right: var(--cds-spacing-150);
  `,
  dialogEntryButton: () => css`
    padding: var(--cds-spacing-50);
    margin-right: var(--cds-spacing-50);
  `,
};

// Component for handling grade override related controls
const GradeOverride: React.FC = () => {
  const { submissionData } = useContext(SGAPageContext);
  const { gradebookEntry } = submissionData.data || {};
  const [openApplyOverrideDialog, setOpenApplyOverrideDialog] = useState(false);
  const [openDeleteOverrideDialog, setOpenDeleteOverrideDialog] = useState(false);

  // toggles the 'applyGradeOverride' dialog
  const toggleApplyOverrideDialog = () => {
    setOpenApplyOverrideDialog((prevState) => !prevState);
  };

  // toggles the 'deleteGradeOverride' dialog
  const toggleDeleteOverrideDialog = () => {
    setOpenDeleteOverrideDialog((prevState) => !prevState);
  };

  return (
    <span data-testid="grade-override" css={styles.container}>
      <TooltipOverlay id="GradeOverrideEdit" text={_t('Override grade')}>
        <Button onClick={toggleApplyOverrideDialog} variant="ghost" size="small" css={styles.dialogEntryButton}>
          <EditIcon size="small" />
        </Button>
      </TooltipOverlay>
      <TooltipOverlay id="GradeOverrideDelete" text={_t('Delete the current grade override')}>
        <Button
          onClick={toggleDeleteOverrideDialog}
          disabled={!gradebookEntry?.overrideOutcome}
          variant="ghost"
          size="small"
          css={styles.dialogEntryButton}
        >
          <TrashIcon size="small" />
        </Button>
      </TooltipOverlay>

      {openApplyOverrideDialog && <ApplyGradeOverrideDialog onClose={toggleApplyOverrideDialog} />}
      {openDeleteOverrideDialog && <DeleteGradeOverrideDialog onClose={toggleDeleteOverrideDialog} />}
    </span>
  );
};

export default GradeOverride;
